import { render, staticRenderFns } from "./analysis.vue?vue&type=template&id=db72eb60&scoped=true&"
import script from "./analysis.vue?vue&type=script&lang=ts&"
export * from "./analysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db72eb60",
  null
  
)

export default component.exports